/**
 * SupportDetails — the raw values, collapsed by default.
 *
 * TCA-26100804. The owner confirmed these numbers are for support rather than
 * daily use, so they are out of the way but still present. They are rendered,
 * not removed: a value hidden behind a disclosure can still be read out on a
 * phone call, and the diagnostic reports that capture them are unaffected.
 *
 * A native disclosure is used deliberately — it is keyboard and screen-reader
 * accessible without any extra wiring.
 */
import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function SupportDetails({ rows = [], testId = 'support-details' }) {
  const visible = (rows || []).filter(([, value]) => value !== null && value !== undefined && value !== '');
  if (!visible.length) return null;

  return (
    <details className="group rounded-xl border border-stone-200 bg-white" data-testid={testId}>
      <summary className="flex cursor-pointer items-center gap-1.5 px-4 py-2.5 text-xs font-semibold text-stone-600 marker:content-['']">
        <ChevronRight
          className="h-3.5 w-3.5 transition-transform group-open:rotate-90"
          aria-hidden="true"
        />
        Details for support
      </summary>
      <dl className="border-t border-stone-100 px-4 py-3 space-y-1.5">
        {visible.map(([label, value, rowTestId]) => (
          <div key={label} className="flex items-baseline justify-between gap-4 text-xs" data-testid={rowTestId}>
            <dt className="text-stone-500">{label}</dt>
            <dd className="text-right font-medium tabular-nums text-stone-700">{value}</dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
